import type { SVGProps } from "react";

/**
 * paperclip-2, attachment
 * @category Interface General
 */
export default function IconPaperclip2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M6.75 8.75V16C6.75 18.8995 9.10051 21.25 12 21.25C14.8995 21.25 17.25 18.8995 17.25 16V5.375C17.25 3.92525 16.0747 2.75 14.625 2.75C13.1753 2.75 12 3.92525 12 5.375V15.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
